export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

export const emailWithoutPlusRegex = /^[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

export const lowAndUpperCasesRegex = /^(?=.*[a-z])(?=.*[A-Z]).+$/

export const mobileRegex = /^(0|(00|\+)33)[6-7][0-9]{8}$/

export const numberRegex = /^(?=.*\d).+$/

export const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/

export const postcodeRegex = /^\d{2}[ ]?\d{3}$/

export const nameRegex = /^[a-zA-ZÀ-ÿ][ 'a-zA-ZÀ-ÿ-]*['a-zA-ZÀ-ÿ]$/i
